import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useNavigate } from "react-router-dom";

const Login = React.lazy(() => import('./components/Login/loginpage.jsx'))
const Layout = React.lazy(() => import('./components/Layout/layout.jsx'))
const NoDataFound = React.lazy(() =>import('./components/common/PlaceholderPages/noDataFound.jsx'))

const Home = React.lazy(() => import('./components/Home/home.jsx'));
const DLFGantChart = React.lazy(() => import('./components/ProjectManagement/GanttChart/ganttContainer.jsx'));
const PUMCHome = React.lazy(() => import('./components/PUMCHome/home.jsx'));
const UserReports = React.lazy(() => import('./components/UserReports/userReports.jsx'));
const Financials = React.lazy(() => import('./components/Financials/financials.jsx'));
const Contracts = React.lazy(() => import('./components/Contracts/contracts.jsx'));
const AISolutions = React.lazy(() => import('./components/AISolutions/aiSolutions.jsx'));
// const Employees = React.lazy(() => import('./components/Employees/employees.jsx'));
const DataMgt = React.lazy(()=> import('./components/DataManagement/dataManagement.jsx') );
const PLFileUpload = React.lazy(()=> import('./components/DataManagement/PLFileUpload/plFileUpload.jsx'))
const CustomersDashboard = React.lazy(()=> import('./components/Customers/customers.jsx'))
const AIAnomalyDetection = React.lazy(()=> import('./components/Property/AIAnomali/aiAnomali.jsx'))
const HotelPricesAnalysis = React.lazy(() => import ('./components/AISolutions/HotelPricesAnalysis/hotelPricesAnalysis.jsx'))

const AnalyticStudio = React.lazy(() => import('./components/AnalyticStudio/analyticStudio.jsx'));

const ProjectManagement = React.lazy(() => import('./components/ProjectManagement/GanttChart/ganttContainer.jsx'));
const PMInsights = React.lazy(()=> import ('./components/ProjectManagement/Insights/index.jsx'))
const MSPFileUpload = React.lazy(()=> import('./components/DataManagement/MSPFileUpload/mspFileUpload.jsx'))

const BulkDataUpload = React.lazy(()=> import('./components/DataManagement/BulkProjectUpload/index.jsx'))

const NonAssociatedGasProduction = React.lazy(() => import('./components/Home/nonAssociatedGasProduction.jsx'))
const Reserves = React.lazy(() => import('./components/Home/reserves.jsx'))
const OperationalExcellence = React.lazy(() => import('./components/Home/operationalExcellence.jsx'))
const Portfolio = React.lazy(() => import('./components/Home/portfolio.jsx'))
const TechnologyCapability = React.lazy(() => import('./components/Home/technologyCapability.jsx'))
const Stakeholders = React.lazy(() => import('./components/Home/stakeholders.jsx'))

const Administration = React.lazy(() => import("./components/Administration/administration.jsx"))
const UserAnalytics = React.lazy(() => import("./components/Administration/UserAnalytics/index.jsx"))

const ForgotPassword = React.lazy(()=> import ('./components/Login/forgotpassword.jsx'))
const UserManagement = React.lazy(() => import('./components/UserManagement/index.jsx'))
const Insights = React.lazy(() => import('./components/Insights/insights.jsx'))
const PUMCInsights = React.lazy(() => import('./components/PUMCInsights/insights.jsx'))
const AssetManagement = React.lazy(()=> import('./components/AssetManagement/assetManagement.jsx'))

const InitiativesLanding = React.lazy(()=> import ('./components/Initiatives/index.jsx'))
const CreateInitiativesLanding = React.lazy(()=> import ('./components/Initiatives/create.jsx'))
const CadenceBoardInitiativesLanding = React.lazy(()=> import ('./components/Initiatives/cadenceBoard.jsx'))
const ViewInitiativesLanding = React.lazy(()=> import ('./components/Initiatives/view.jsx'))


const FunctionalPlanning = React.lazy(() => import('./components/ExtendedPlanning/FunctionalPlanning/index.jsx'));
const SimulationPlanning = React.lazy(() => import('./components/ExtendedPlanning/SimulationPlanning/index.jsx'));
const KpiBasedPlanning = React.lazy(() => import('./components/ExtendedPlanning/KPIBasedPlanning/index.jsx'));
const DetailedPlanning = React.lazy(() => import('./components/ExtendedPlanning/DetailedPlanning/index.jsx'));
const IntegratedPlanning = React.lazy(() => import('./components/ExtendedPlanning/IntegratedPlanning/index.jsx'));
const EsfForecast = React.lazy(() => import('./components/ExtendedPlanning/ESFForecast/index.jsx'));

const GanttChartInsights = React.lazy(() => import('./components/Moh-KL/InsightsGantChart/index.jsx'))
const GanttChartInsightsDLF = React.lazy(() => import('./components/ProjectManagementDLF/Insights/index.jsx'))
const GeoInsights = React.lazy(() => import('./components/Moh-KL/InsightsGeographicAnalysis/index.jsx'));
const AISearch = React.lazy(()=> import('./components/AISolutions/AISearch/aiSearch.jsx'))


const PrivateRoutes = () => {
  const auth = localStorage.getItem('loggedInUser')
  return (
    auth ? <Outlet /> : <Navigate to='/login' />
  )
}

const PrivateRoutesPWA = () => {
  const auth = localStorage.getItem('loggedInUser')
  return (
    auth ? <Outlet /> : <Navigate to='/pwa-login' />
  )
}

function Loading() {
  return <h2>🌀 Loading...</h2>;
}

export default function Router() {

  return (
    <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ForgotPassword />} />



       

          <Route element={<PrivateRoutes />}>
            <Route path="/home/*" element={<Layout />} />



              <Route path="/app" element={<Layout />} >
              <Route index element={<PUMCHome />} />
              <Route path="/app/insights" element={<Insights />} />
              <Route path="user-management" element={<UserManagement />} />
              <Route path="/app/financials" element={<Financials />}/>
              <Route path="/app/user-reports" element={<UserReports />} />
              <Route path="/app/analytic-studio" element={<AnalyticStudio/>} />
              <Route path="/app/planning" element={<AISolutions />}/>
              <Route path="/app/employees" element={<NoDataFound />}/>
              <Route path ='/app/asset-management' element={<AssetManagement />} />
              <Route path="/app/data-mgt" element={<DataMgt />}/>
              <Route path="/app/data-mgt/pl-file-upload" element={<PLFileUpload />}/>
              <Route path="/app/data-mgt/ai-anomaly-detection" element={<AIAnomalyDetection />}/>

              <Route path ='/app/gantt-chart' element={<PUMCHome mode='gantt-moh' />} />
              <Route path ='/app/gantt-dlf' element={<PUMCHome mode='gantt-dlf' />} />
              <Route path ='/app/reserves' element={<Reserves />} />
              <Route path ='operational-excellence' element={<OperationalExcellence />} />
              <Route path ='/app/portfolio' element={<Portfolio />} />
              <Route path ='/app/technology-capability' element={<TechnologyCapability />} />
              <Route path ='/app/stakeholders' element={<Stakeholders />} />
              <Route path ='/app/pm-insights' element={<PMInsights />} />
              <Route path="/app/data-mgt/msp-file-upload" element={<MSPFileUpload />}/>              
              <Route path="/app/data-mgt/bulk-data-upload" element={<BulkDataUpload />}/>
              <Route path="/app/receivables" element={<NoDataFound />} />

              <Route path="/app/contracts" element={<Contracts />} />
              <Route path="/app/project-management" element={<ProjectManagement />} />
              
              <Route path="/app/customers" element={<CustomersDashboard />} />

              <Route path ='/app/initiatives' element={<InitiativesLanding />} />
              <Route path ='/app/initiatives/create' element={<CreateInitiativesLanding />} />
              <Route path ='/app/initiatives/cadence-board' element={<CadenceBoardInitiativesLanding />} />
              <Route path ='/app/initiatives/view' element={<ViewInitiativesLanding />} />

              <Route path ='/app/planning/functional-planning' element={<FunctionalPlanning />} />
              <Route path ='/app/planning/simulation-based' element={<SimulationPlanning />} />
              <Route path ='/app/planning/kpi-based' element={<KpiBasedPlanning />} />
              <Route path ='/app/planning/detailed' element={<DetailedPlanning />} />
              <Route path ='/app/planning/integrated-planning' element={<IntegratedPlanning />} />
              <Route path ='/app/planning/esf-forecast' element={<EsfForecast />} />

              <Route path = '/app/ai-solutions' element={<AISearch />} />

              <Route path="/app/gantt-insights" element={<GanttChartInsights />} />
              <Route path="/app/gantt-insights-dlf" element={<GanttChartInsightsDLF />} />
              <Route path="/app/geospatial-insights" element={<GeoInsights />} />
              
              <Route path="/app/data-mgt/user-analytics" element={<UserAnalytics />} exact />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </Suspense>

  );
}
